import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-main-bilan-sante',
  imports: [RouterOutlet],
  templateUrl: './main-bilan-sante.component.html',
  styleUrl: './main-bilan-sante.component.scss'
})
export class MainBilanSanteComponent {}
